<template>
  <div>
    <div class="row">

      <div class="col-lg-3 col-md-6">
        <div class="form-group">
          <label>Matrícula</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="far fa-address-card"></i></span>
            <input id="inputError" maxlength="8" type="text" v-model="plate" class="form-control" v-on:keyup="checkPlatePattern" placeholder="Matrícula (ej: 5819 KNF)" pattern="^[0-9]{4} ?[BCDFGHJKLMNPQRSTVWXYZ]{3}" required />
          </div>
          <!--<span class="help-block" v-if="!plateValidation">El texto introducido no corresponde con una matrícula válida. (ej: 0000 BBB, 0000BBB)</span>-->
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="form-group">
          <label>Marca</label>
          <vue-multiselect
              v-model="maker"
              label="name"
              :options="makers"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              deselectLabel="quitar"
              placeholder="Seleccionar marca"
              @input="onMakerChanged"></vue-multiselect>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="form-group">
          <label>Modelo</label>
          <vue-multiselect
              v-model="model"
              label="name"
              :options="models"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              deselectLabel="quitar"
              placeholder="Seleccionar modelo"
              @input="onModelChanged">
            <span slot="noResult"></span>
            <span slot="noOptions"><small>(primero selecciona una marca)</small></span>
          </vue-multiselect>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="form-group">
          <label>Tipo de publicación</label>
          <vue-multiselect
              v-model="publicationType"
              label="name"
              :options="publicationTypes"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="Selecciona tipo de publicación"
              @input="onPublicationTypeChanged">
            <span slot="noResult"></span>
            <span slot="noOptions"></span>
          </vue-multiselect>
        </div>
      </div>
    </div>

    <div class="row">

      <div class="col-lg-3 col-md-6">
        <div class="form-group">
          <label>Concesión</label>
          <vue-multiselect
              v-model="dealership"
              label="name"
              :options="dealerships"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="Concesionario"
              @input="onDealershipChanged">
            <span slot="noResult"></span>
            <span slot="noOptions"></span>
          </vue-multiselect>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="form-group">
          <label>Sociedad</label>
          <vue-multiselect
              v-model="society"
              label="name"
              :options="societies"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="Sociedad"
              @input="onSocietyChanged">
            <span slot="noResult"></span>
            <span slot="noOptions"></span>
          </vue-multiselect>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="form-group">
          <label for="exampleInputEmail1">Email address</label>
          <input type="email" class="form-control" id="exampleInputEmail1" placeholder="">
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="form-group">
          <label>Estado del vehículo</label>
          <vue-multiselect
              v-model="carStatus"
              label="name"
              :options="carStatuses"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              deselectLabel="quitar"
              placeholder="Seleccionar estado del vehículo"
              @input="onCarStatusChanged">
          </vue-multiselect>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="form-group">
          <label>Nº Bastidor</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="far fa-address-card"></i></span>
            <input
              id="inputError"
              type="text"
              v-model="vin"
              class="form-control"
              v-on:blur="onVinChanged"
              placeholder="Nº Bastidor"
            />
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import util from '@/utils/util'
import vueMultiselect from 'vue-multiselect'
import webservice from '@/utils/webservice'

export default {
  name: 'SearchFilters',
  components: {vueMultiselect},

  data () {
    return {
      maker: null,
      makers: [{ 'id': -1, 'name': '(ver todos)' }, ...util.makers],
      model: null,
      models: [],
      plate: '',
      plateValidation: true,
      carStatus: null,
      carStatuses: [{ 'id': -1, 'name': '(ver todos)' }, ...util.carStatuses],
      dealership: null,
      dealerships: [{ 'id': -1, 'name': '(ver todos)' }, ...util.dealerships],
      society: null,
      societies: [],
      publicationTypes: [{ 'id': -1, 'name': '(ver todos)' }, ...util.carTypes],
      publicationType: null,
      vin: ''
    }
  },

  mounted () {
    window.searchParams = '?status=true'
    webservice.dealer.findDealerships().then(dealerships => {
      this.dealerships = [{ 'id': -1, 'name': '(ver todos)' }, ...dealerships]
    })

    webservice.dealer.findSocieties().then(societies => {
      this.societies = [{ 'id': -1, 'name': '(ver todos)' }, ...societies]
    })
  },

  methods: {

    onSocietyChanged () {
      if (this.society.id === -1) {
        this.society = null
      }
      this.filtersChanged()
    },

    onDealershipChanged () {
      if (this.dealership.id === -1) {
        this.dealership = null
      }
      this.filtersChanged()
    },

    onMakerChanged () {
      if (this.maker != null && this.maker.id > 0) {
        this.model = null
        this.models = [{ 'id': -1, 'name': '(ver todos)' }, ...util.modelsByMaker(this.maker.id)]
      } else {
        if (this.maker.id === -1) {
          this.maker = null
        }
        this.model = null
        this.models = []
      }
      this.filtersChanged()
    },
    onModelChanged () {
      if (this.model.id === -1) {
        this.model = null
      }
      this.filtersChanged()
    },

    onCarStatusChanged () {
      if (this.carStatus.id === -1) {
        this.carStatus = null
      }
      this.filtersChanged()
    },

    checkPlatePattern () {
      this.plate = this.plate.toUpperCase().trim()
      this.plateValidation = this.plate === '' || (this.plate.match(/^[0-9]{4} ?[BCDFGHJKLMNPQRSTVWXYZ]{3}/) !== null)
      if ((this.plateValidation && this.plate !== '') && this.plate.indexOf(' ') === -1) {
        this.plate = this.plate.substring(0, 4) + ' ' + this.plate.substring(4, 7)
      }
      this.filtersChanged()
    },

    onPublicationTypeChanged () {
      if (this.publicationType.id === -1) {
        this.publicationType = null
      }
      this.filtersChanged()
    },

    onVinChanged () {
      if (this.vin === '') {
        this.vin = null
      }
      this.filtersChanged()
    },

    filtersChanged () {
      let maker = this.maker !== null ? this.maker.id : null
      let model = this.model !== null ? this.model.id : null
      let plate = this.plate.trim() !== '' ? this.plate : null
      let carStatus = this.carStatus !== null ? this.carStatus.id : null
      let vin = this.vin !== null ? this.vin : null
      let dealership = this.dealership !== null ? this.dealership.id : null
      let society = this.society !== null ? this.society.id : null
      let publicationType = this.publicationType !== null ? this.publicationType.id : null

      let params = ''
      if (maker !== null) {
        params += `&maker=${maker}`
      }
      if (model !== null) {
        params += `&model=${model}`
      }
      if (plate !== null) {
        params += `&plate=${plate}`
      }

      if (carStatus !== null) {
        params += `&publicationStatus=${carStatus}`
      }

      if (vin !== null) {
        params += `&vin=${vin}`
      }

      if (dealership !== null) {
        params += `&dealership=${dealership}`
      }

      if (society !== null) {
        params += `&society=${society}`
      }

      if (publicationType !== null) {
        params += `&publicationType=${publicationType}`
      }

      if (params === '') {
        params = null
      }

      if (window.hasOwnProperty('onSearchParamsChanged') && window.onSearchParamsChanged !== null) {
        window.onSearchParamsChanged(params)
      } else {
        this.$emit('searchParamsChanged', { maker, model, plate, carStatus, dealership, society, publicationType, params })
      }

      console.log(window.searchParams, { maker, model, plate, carStatus, dealership, society, publicationType, params })
    }
  }
}
</script>

<style lang="scss">
  @import 'vue-multiselect/dist/vue-multiselect.min.css';
  #datatable_filter {
    display: none !important;
  }
</style>

<style lang="scss" scoped>
  .input-group {
    min-height: 40px !important;

    .input-group-addon {
      border: 1px solid rgb(232, 232, 232);
      border-image-source: initial;
      border-image-slice: initial;
      border-image-repeat: initial;
      border-right: 0;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }

    .form-control {
      min-height: 40px !important;

      border: 1px solid rgb(232, 232, 232);
      border-top: initial none;
      border-image-source: initial;
      border-image-slice: initial;
      border-image-repeat: initial;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;

    }
  }

  .multiselect--active {
    z-index: 9999;
  }

</style>

<style lang="scss">
  .multiselect__content .multiselect__element:first-child {
    .multiselect__option--highlight {
      background: rgba(204, 204, 204, 0.49) !important;
      color: #000000;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/custom/SearchFilters.vue